var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup4237 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4237",
    "data-name": "Group 4237",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.709,
    height: 25.045,
    viewBox: "0 0 19.709 25.045",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2846",
    "data-name": "Rectangle 2846",
    width: 19.709,
    height: 25.045,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4465",
    "data-name": "Path 4465",
    d: "M9.855,0a9.723,9.723,0,0,1,9.855,9.591,11.808,11.808,0,0,1-.884,4.317C16.821,18.424,12,23.2,10.4,24.752c-.408.363-.578.429-1.088-.032C7.68,23.17,2.922,18.457.918,13.975A13.581,13.581,0,0,1,0,9.591,9.723,9.723,0,0,1,9.855,0",
    transform: "translate(0 0)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    "data-name": "Path 4466",
    d: "M19.112,11.491a7.487,7.487,0,0,1-7.6,7.369,7.486,7.486,0,0,1-7.6-7.369,7.486,7.486,0,0,1,7.6-7.369,7.487,7.487,0,0,1,7.6,7.369",
    transform: "translate(-1.659 -1.818)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4467",
    "data-name": "Path 4467",
    d: "M16.7,13.182a.469.469,0,0,0-.318-.126h-.7a.451.451,0,0,0-.123.016v-.463a1.183,1.183,0,0,0-.94-.911H7.631a1.183,1.183,0,0,0-.939.911v4.447a1.183,1.183,0,0,0,.939.911h6.993a1.183,1.183,0,0,0,.94-.911v-.463a.454.454,0,0,0,.123.016h.7a.459.459,0,0,0,.264-.083l2.038.547V12.649ZM8.73,15.574a.742.742,0,1,1,.764-.742.753.753,0,0,1-.764.742m7.763.5c0,.09-.056.157-.107.157h-.7c-.056,0-.107-.075-.107-.157v-2.49c0-.082.051-.158.107-.158h.7c.05,0,.107.068.107.158Z",
    transform: "translate(-2.835 -5.159)",
    fill: "#737373"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup4237);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 4237.17f1149a023f6dc4a5a5232fdcf04871.svg";